<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {}
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        watch: {
            step: function (val) {
                switch (val) {
                    case 2:
                        $('html, body').animate({scrollTop: 1500}, 'slow')
                        break
                    case 3:
                        if (window.innerHeight < 860) {
                            $('html, body, .nav-menu').animate({scrollTop: 100}, 'slow')
                        } else {
                            $('html, body, .nav-menu').animate({scrollTop: 0}, 'slow')
                        }
                        break
                }
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 3) {
                    window.location = '17.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-16.vue